import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { PartCostCalculationPage } from "src/components/views/erp/parts/siteParts/PartCostCalculationPage.tsx";

export const Route = createFileRoute("/_authenticated/_shell/warehouse/partCostCalculation")({
	staticData: { title: i18n.t("warehouse_parts"), legacyViewKey: "partCostCalculationPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <PartCostCalculationPage />;
}
